// CardVideoGallery.tsx
import * as React from 'react';
import { Presentation } from '../services/PresentationsAboutServiceProvider';
import { PresentationLink } from '../types/presentationLink';
import { GalleryImage } from '../types/galleryImage';
import { PageProps } from '../types/navigationProperties';
import { Grid, Typography, Tooltip, Card, CardMedia, CardContent, Divider, Zoom as M_ZOOM } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import { VideoLightShot } from '../components/VideoLightShot';

export default function CardVideoGallery({ props, pageProps }: { props: Presentation[] | undefined, pageProps: PageProps }) {

    const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);
    const [index, setIndex] = React.useState(0);
    const [selectedVideos, setSelectedVideos] = React.useState<PresentationLink[]>();
    const slideshowDelay: number = 3000;
    const fadeDelay: number = 300;
    const swipeDelay: number = 300;
    const zoomDelay: number = 300;

    const updateIndex =  (when: boolean) => ({ index: current }: { index: number }) => {
        if (when === open) {
            setIndex(current);
        }
    };

    function sortVideosByIndex<T>(arr: T[], index: number): T[] {
        // Check if the index is valid
        if (index < 0 || index >= arr.length) {
            console.warn("Index out of bounds.");
            return arr; // Return what is provided if index is invalid
        }

        // splice(startIndex, deleteCount) removes elements starting from startIndex
        // and returns an array containing the removed elements.
        const removedItems = arr.splice(index, 1);

        // If an item was successfully removed, return the first (and only) item
        return removedItems.length > 0 ? removedItems : arr;
    }

    const handleOpenLightShot = (event: React.MouseEvent<HTMLDivElement>, items: PresentationLink[], index: number) => {
        const targetElement = event.target as HTMLElement;
        if(targetElement.nodeName.indexOf('svg') <= -1) {
            const myVideos  = [...items];
            let firstItem = sortVideosByIndex(myVideos, index);
            setSelectedVideos([...firstItem, ...myVideos]);
            setOpen(true);
        }
    }

    const getVideoPreviewSlides = (items: PresentationLink[]) => {
        let slides = items.map((item: PresentationLink) => { let slide: GalleryImage = { src: item.thumbnail, name: item.thumbnail }; return slide; });
        console.log('slides');
        console.log(slides);
        if(slides.length > 0) {
            slides.map((item: GalleryImage) => {
                if(item.src !== null) {
                    const videoId = item.src.match(/(?:embed\/|v=)([\w-]{11})/);
                    if(videoId !== null) {
                        item.src = `https://img.youtube.com/vi/` + videoId[1] + `/maxresdefault.jpg`
                    }
                }
            });
            return slides.slice(0, 3);
        }
        return slides;
    }

    return (
        <Grid container spacing={2}>
            <VideoLightShot videos={selectedVideos} opened={open} setOpenLightShot={setOpen} />
            {props !== undefined && props.map((item: any, index: number) => (
                <Grid size={{ xs: 12, sm: 12, md: props.length > 1 ? 6 : 12 }} key={index} sx={{ width: '100%'}}>
                    <Tooltip title={t("open.gallery") + " - " + item.title.value}
                             placement="top"
                             slots={{
                                transition: M_ZOOM,
                             }}
                             slotProps={{
                                transition: { timeout: 300 },
                             }} arrow>
                        <Card sx={{ backgroundColor: 'rgb(255, 255, 255)', '&:hover': { cursor: 'pointer' } }}
                              onClick={((event) => handleOpenLightShot(event, item.presentation_video_links, index))} >
                            <CardMedia sx={{ height: 200 }}>
                            <Lightbox slides={getVideoPreviewSlides(item.presentation_video_links)}
                                    plugins={[Inline, Slideshow]}
                                    on={{
                                        click: () => setOpen(false),
                                    }}
                                    slideshow={{
                                        autoplay: true,
                                        delay: slideshowDelay
                                    }}
                                    animation={{
                                        fade: fadeDelay,
                                        swipe: swipeDelay,
                                        zoom: zoomDelay
                                    }}
                                    carousel={{
                                        padding: 0,
                                        spacing: 0,
                                        imageFit: "cover",
                                    }}
                                    inline={{
                                        style: {
                                            width: "100%",
                                            height: '200px',
                                            aspectRatio: "3 / 2",
                                            margin: "0 auto",
                                        },
                                    }} />
                            </CardMedia>
                            <Divider sx={{ my: 2, marginTop: '50px', borderColor: 'rgb(0, 0, 0)' }} />
                            <CardContent>
                                <Typography gutterBottom>
                                    { item.title.value ? item.title.value.toUpperCase() : '' }
                                </Typography>
                                <Typography color="textSecondary" component="p">
                                    { item.description.value }
                                </Typography>
                            </CardContent>
                        </Card>
                    </Tooltip>
                </Grid>
            ))}
        </Grid>
    )
}

